import React, { FC, Fragment } from 'react';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Card } from '@components/atoms/Card';
import styles from './ManagementCard.module.css';

interface ManagementCardProps {
    title: string;
    content: { label: string; content: JSX.Element | string }[];
}

export const ManagementCard: FC<ManagementCardProps> = ({ title, content }) => {
    return (
        <div className="col-12 col-md-6" data-testid="management-card">
            <Card classes={styles['management-card']}>
                <div className={`${styles['card-header']} row m-0`}>
                    <div className="col-12">
                        <Typography tagVariant={TypographyTagVariants.h2} classes={`card-title ${styles['card-title']}`}>
                            {title}
                        </Typography>
                    </div>
                </div>
                <div className={`${styles['card-body']} row m-0`}>
                    <div className={`col-12 ${styles['two-column-grid']}`}>
                        {content.map((item, index) => (
                            <Fragment key={`content-${index}`}>
                                <Typography color="muted" classes="mb-0" fontSize="14">
                                    {item.label}
                                </Typography>
                                {typeof item.content === 'string' ? (
                                    <Typography classes="mb-0" fontSize="16">
                                        {item.content}
                                    </Typography>
                                ) : (
                                    <div>{item.content}</div>
                                )}
                            </Fragment>
                        ))}
                    </div>
                </div>
            </Card>
        </div>
    );
};
